<div class="d-flex flex-row align-items-center auto-recovery-header dialog-gap fw-bold">
  <i class="fs-5 {{ modalData?.icon }}"></i>
  <h5 class="m-0 bold">{{ modalData?.header }}</h5>
</div>

@if (modalData?.ccwSelectServiceProvider?.selectedServiceProvider) {
  <div>
    <div class="flex-wrap-column mx-1">
      <label class="control-label flex align-content-start flex-wrap">Select a Service Provider Workflow</label>
      <div class="d-flex align-items-center dialog-gap mt-3 mb-3">
        @for (option of serviceProviderOptions; track option; let i = $index) {
          <div>
            <div class="radiobutton-container">
              <p-radiobutton
                [(ngModel)]="modalData.ccwSelectServiceProvider.selectedServiceProvider"
                [value]="option"
                [disabled]="(isCcwDisabled$ | async) || isSpecificProviders"
                [inputId]="'serviceProviderOptions' + i"
              />
              <label class="control-label" [innerHTML]="option" [for]="'serviceProviderOptions' + i"></label>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

<p class="message mt-0" [innerHTML]="modalData?.message"></p>

<div class="d-flex flex-row justify-content-between mb-0">
  <div>
    @if (modalData?.showReportButton) {
      <button severity="danger" pButton type="button" (click)="report()">
        <span class="pi pi-megaphone pt-0"></span>
        Report an Issue
      </button>
    }
  </div>
  <div class="d-flex justify-content-end mb-0 dialog-gap">
    @if (modalData?.rejectLabel) {
      <button pButton type="button" severity="secondary" (click)="reject()">
        @if (modalData?.rejectIcon) {
          <span class="p-button-icon p-button-icon-left {{ modalData?.rejectIcon }}"></span>
        }
        {{ modalData?.rejectLabel }}
      </button>
    }
    @if (modalData?.acceptVisible) {
      <button pButton #acceptButton type="button" [class]="modalData?.acceptButtonStyleClass" (click)="accept()">
        @if (modalData?.acceptIcon) {
          <span class="p-button-icon p-button-icon-left {{ modalData?.acceptIcon }}"></span>
        }
        {{ modalData?.acceptLabel }}
      </button>
    }
  </div>
</div>
